import * as React from "react";
import { ArrowRight, Clock, CirclePlay } from "lucide-react";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Button } from "@/components/ui/button";
import { ScrollArea } from "@/components/ui/scroll-area";
const featuredVideo = {
  title: "איך לבחור מטפל סיעודי שיתאים בדיוק למשפחה שלכם",
  description: "המדריך המקיף של סיעוד מיידי על שלבי הבדיקה, התאמת הציפיות והבטחת טיפול מקצועי ואנושי ליקירכם. כל מה שצריך לדעת לפני שמתחילים.",
  thumbnail: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/video_thumbnail_nursing_care.png",
  duration: "12:15",
  href: "/ProfessionalBlogPage"
};
const articles = [{
  id: 1,
  title: "זכויות סיעוד בביטוח לאומי: מה מגיע לכם?",
  excerpt: "מדריך מפורט על גמלת סיעוד, מבחני תפקוד ואיך לקבל את העזרה המקסימלית המגיעה לכם מהמדינה.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/article_social_security.png",
  date: "12 בנוב׳ 2023",
  href: "/ProfessionalBlogPage"
}, {
  id: 2,
  title: "השגחה בבית חולים – למה זה קריטי להחלמה?",
  excerpt: "חשיבות הליווי הצמוד לאחר ניתוח או באשפוז ממושך למניעת סיבוכים והאצת תהליך השיקום של המטופל.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/article_hospital_care.png",
  date: "05 בנוב׳ 2023",
  href: "/ProfessionalBlogPage"
}, {
  id: 3,
  title: "כמה עולה מטפל סיעודי פרטי בישראל?",
  excerpt: "סקירת מחירים מעודכנת, אפשרויות סבסוד וההבדלים המהותיים בין מסלולי הטיפול וההשגחה השונים.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/article_cost_nursing.png",
  date: "28 באוק׳ 2023",
  href: "/ProfessionalBlogPage"
}, {
  id: 4,
  title: "טיפים להתמודדות רגשית בטיפול בהורה מבוגר",
  excerpt: "כלים פרקטיים וטכניקות שיעזרו לכם לשמור על איזון וחוסן נפשי בזמן שאתם דואגים ליקרים לכם.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/article_emotional_support.png",
  date: "15 באוק׳ 2023",
  href: "/ProfessionalBlogPage"
}, {
  id: 5,
  title: "שיקום ביתי: יתרונות הטיפול בסביבה המוכרת",
  excerpt: "למה הבית הוא המקום הטוב ביותר להחלמה ואיך מייצרים תנאים אופטימליים לשיקום מוצלח ובטוח.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/article_home_rehab.png",
  date: "02 באוק׳ 2023",
  href: "/ProfessionalBlogPage"
}];
export default function LatestVideoGuidesAndArticles() {
  return <section data-section-id="200533" id="מאמרים-אחרונים" className="bg-background text-foreground py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        
        <div className="mb-10 flex flex-col items-start justify-between gap-4 border-b border-border pb-6 sm:flex-row sm:items-end">
          <div>
            <h2 className="text-3xl font-default font-bold tracking-tight text-foreground md:text-4xl">
              מדריכים ומאמרים מקצועיים
            </h2>
            <p className="mt-2 text-muted-foreground font-default">
              ידע מקצועי וכלים מעשיים עבורכם ועבור יקיריכם בעולם הסיעוד
            </p>
          </div>
          <Button variant="outline" asChild className="shrink-0 rounded-xl border-primary text-primary hover:bg-primary/5">
            <Link to="#">
              לכל המאמרים והמדריכים
              <ArrowRight className="ml-2 size-4 rotate-180" />
            </Link>
          </Button>
        </div>

        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-8">
          
          <div className="flex flex-col gap-6 lg:col-span-7">
            <Link to={featuredVideo.href} className="group relative block w-full overflow-hidden bg-muted rounded-xl shadow-sm">
              <AspectRatio ratio={16 / 9}>
                <img src={featuredVideo.thumbnail} alt={featuredVideo.title} className="size-full object-cover transition-transform duration-500 group-hover:scale-105" />
                <div className="absolute inset-0 bg-black/20 transition-colors duration-300 group-hover:bg-black/40" />
                
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="flex size-16 items-center justify-center bg-primary text-primary-foreground rounded-lg shadow-xl transition-transform duration-300 group-hover:scale-110">
                    <CirclePlay className="size-8" />
                  </div>
                </div>

                <div className="absolute bottom-4 right-4 bg-black/80 px-2 py-1 text-xs font-default font-medium tracking-wider text-white rounded-sm">
                  {featuredVideo.duration}
                </div>
              </AspectRatio>
            </Link>

            <div className="flex flex-col gap-3">
              <div className="flex items-center gap-2 text-sm font-default font-medium text-primary">
                <span className="bg-secondary px-2 py-1 text-xs text-secondary-foreground rounded-sm font-default">מדריך וידאו נבחר</span>
              </div>
              <h3 className="text-2xl font-default font-bold text-foreground">
                <Link to={featuredVideo.href} className="hover:text-primary transition-colors">
                  {featuredVideo.title}
                </Link>
              </h3>
              <p className="text-base text-muted-foreground leading-relaxed font-default">
                {featuredVideo.description}
              </p>
            </div>
          </div>

          <div className="flex flex-col lg:col-span-5">
            <div className="mb-6 flex items-center justify-between">
              <h3 className="text-xl font-default font-bold text-foreground">פרסומים אחרונים</h3>
            </div>
            
            <ScrollArea className="h-[500px] pr-4">
              <div className="flex flex-col gap-6">
                {articles.map((article, i) => <Link key={article.id} to={article.href} className="group flex flex-col gap-4 sm:flex-row sm:items-start" data-index={i}>
                    <div className="relative aspect-video w-full shrink-0 overflow-hidden bg-muted sm:w-32 sm:aspect-square rounded-xl shadow-sm">
                      <img src={article.image} alt={article.title} className="size-full object-cover transition-transform duration-500 group-hover:scale-105" />
                    </div>
                    
                    <div className="flex flex-1 flex-col gap-2">
                      <div className="flex items-center gap-1.5 text-xs text-muted-foreground font-default">
                        <Clock className="size-3.5" />
                        <time dateTime={article.date}>{article.date}</time>
                      </div>
                      <h4 className="font-default font-bold leading-tight text-foreground transition-colors group-hover:text-primary line-clamp-2">
                        {article.title}
                      </h4>
                      <p className="text-sm text-muted-foreground line-clamp-2 font-default">
                        {article.excerpt}
                      </p>
                    </div>
                  </Link>)}
              </div>
            </ScrollArea>
            
            <div className="mt-6 pt-6 border-t border-border">
              <Button variant="ghost" className="w-full justify-center text-primary font-default font-medium hover:text-primary hover:bg-secondary/10 rounded-xl" asChild>
                 <Link to="#">
                    למעבר לארכיון המאמרים המלא
                 </Link>
              </Button>
            </div>
          </div>

        </div>
      </div>
    </section>;
}